import { useState, useEffect } from 'react';
import "./Home.css";

const Home = () => {
    const [showCurtain, setShowCurtain] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowCurtain(false); 
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        const curtainTimer = setTimeout(() => {
            setShowCurtain(false);
        }, 2000);

        const scrollLockTimer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 2000);

        return () => {
            clearTimeout(curtainTimer);
            clearTimeout(scrollLockTimer);
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <>
            {showCurtain && (
                <>
                    <div className="curtain left-curtain" />
                    <div className="curtain right-curtain" />
                </>
            )}

            <section className="home-container" id="home">
                <div className="hero-text">
                    <h2 className="hero-title">Hello!</h2>
                    <p className="hero-subtitle">Weekend Developer</p>
                </div>

                <div className="image-row">
                    <img src={process.env.PUBLIC_URL + '/assets/images/top/top01.png'} className="image-placeholder" />
                    <img src={process.env.PUBLIC_URL + '/assets/images/top/top03.png'} className="image-placeholder" />
                    <img src={process.env.PUBLIC_URL + '/assets/images/top/top06.png'} className="image-placeholder" />
                    <img src={process.env.PUBLIC_URL + '/assets/images/top/top04.png'} className="image-placeholder" />
                </div>

            </section>
        </>
    );
}

export default Home;
